import { Line } from 'react-chartjs-2';
import {
  CategoryScale,
  Chart,
  type ChartOptions,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  type ChartData
} from 'chart.js';
import { useChart } from '../shared/hooks';
import { CHART_TYPE } from '../shared/types';
import { type ChartValuesCount } from 'src/shared/types/chartsData';

Chart.register(CategoryScale, LinearScale, LineController, LineElement, PointElement);

type LineChartProps = {
  data: ChartValuesCount;
  labels: string[];
  stacked: boolean;
};

const LineChart = ({ data, labels, stacked = false }: LineChartProps) => {
  const { chartData, options } = useChart(CHART_TYPE.LINE, data, labels, stacked);
  if (!chartData) {
    return <></>;
  }
  return <Line data={chartData as ChartData<'line'>} options={options as ChartOptions<'line'>} />;
};

export default LineChart;
